import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "md:w-[640px] min-h-screen pb-40 w-full" }
const _hoisted_2 = ["src"]

import { ref, computed, watch } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'ColumnModal',
  setup(__props) {

const store = useStore();
const route = useRoute();

const postUrl = computed(() => store.state.columnNewsUrl);

// 모든 채널 데이터에 대한 computed 속성
const allData = computed(() => store.getters.allChannelData);

// 선택된 게시물에 대한 computed 속성
const selectedPost = computed(() => {
    const index = Number(route.params.id); // route.params.id를 숫자로 변환
    return allData.value.find(data => data.id === index);
});

// selectedPost의 변경사항을 감시하고, 해당 게시물의 htmlLink1 값을 SET_COLUMN_URL 커밋으로 저장
watch(selectedPost, (newVal) => {
    if (newVal && newVal.htmlLink1) {
        store.commit('SET_COLUMN_URL', newVal.htmlLink1);
    }
}, { immediate: true }); // immediate: true 옵션으로 컴포넌트 마운트 시 즉시 실행




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("iframe", {
      id: "imported-content",
      src: postUrl.value,
      width: "100%",
      height: "100%",
      frameborder: "0",
      style: {"height":"100vh"}
    }, null, 8, _hoisted_2)
  ]))
}
}

})